export type LocationComposerCopySettings = Record<string, unknown>;

export const LOCATION_COMPOSER_COPY_DEFAULTS: LocationComposerCopySettings = {
  intro: {
    title: 'Where are you playing today?',
    subtitle: 'Move the map to pin a new location, or tap an existing spot to plan a game.',
  },
  search: {
    placeholder: 'Search address or venue',
  },
  selectedLocation: {
    placeholder: 'Move the map to pin a new location',
  },
  primaryCta: {
    label: 'Play here',
  },
  tabs: {
    topSpots: 'Top Spots',
    recentActivity: 'Recent Activity',
  },
  emptyState: {
    title: 'Nothing here yet',
    body: 'Drop a pin or search nearby to get something started.',
  },
  contexts: {
    styles: {
      game: {
        primaryCta: { label: 'Play {activityLabel}' },
      },
      workout: {
        intro: {
          title: 'Where are you working out today?',
          subtitle: 'Move the map to pin a gym or workout spot, or tap an existing spot to plan a workout.',
        },
        selectedLocation: { placeholder: 'Move the map to pin a gym or workout spot' },
        primaryCta: { label: 'Workout Here' },
      },
      session: {
        intro: {
          title: 'Where are you {activityQuestionPhrase} today?',
          subtitle: 'Move the map to pin a spot, or tap an existing spot to plan {activityPlanPhrase}.',
        },
        primaryCta: { label: '{activityPrimaryCta}' },
      },
      run: {
        intro: {
          title: 'Where are you running today?',
          subtitle: 'Move the map to pin a start spot, track, or meetup point, or tap an existing spot to plan a run.',
        },
        selectedLocation: { placeholder: 'Move the map to pin a start spot' },
        primaryCta: { label: 'Run here' },
      },
    },
    sports: {
      weightlifting: {
        intro: {
          title: 'Where are you lifting today?',
          subtitle: 'Move the map to pin a gym, or tap an existing spot to plan a lift session.',
        },
        selectedLocation: { placeholder: 'Move the map to pin a gym' },
        primaryCta: { label: 'Workout Here' },
      },
    },
    variants: {},
  },
};
